import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalOutlinedMapIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 13 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6951 8.93977C10.1711 10.0015 9.46176 11.0601 8.73505 12.01C8.01062 12.957 7.28372 13.7768 6.73698 14.3605C6.66433 14.438 6.59496 14.5113 6.5293 14.5801C6.46364 14.5113 6.39426 14.438 6.32161 14.3605C5.77487 13.7768 5.04798 12.957 4.32354 12.01C3.59684 11.0601 2.88754 10.0015 2.36353 8.93977C1.8341 7.86708 1.5293 6.86191 1.5293 6C1.5293 3.23858 3.76787 1 6.5293 1C9.29072 1 11.5293 3.23858 11.5293 6C11.5293 6.86191 11.2245 7.86708 10.6951 8.93977ZM6.5293 16C6.5293 16 12.5293 10.3137 12.5293 6C12.5293 2.68629 9.84301 0 6.5293 0C3.21559 0 0.529297 2.68629 0.529297 6C0.529297 10.3137 6.5293 16 6.5293 16Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5293 8C5.42473 8 4.5293 7.10457 4.5293 6C4.5293 4.89543 5.42473 4 6.5293 4C7.63387 4 8.5293 4.89543 8.5293 6C8.5293 7.10457 7.63387 8 6.5293 8ZM6.5293 9C8.18615 9 9.5293 7.65685 9.5293 6C9.5293 4.34315 8.18615 3 6.5293 3C4.87244 3 3.5293 4.34315 3.5293 6C3.5293 7.65685 4.87244 9 6.5293 9Z",
			fill: "#4B7987"
		})
	]
});
const ForwardRef = forwardRef(SvgPortalOutlinedMapIcon);
const Memo = memo(ForwardRef);
export default Memo;
